export const IS_EDIT_MODE_ENABLED =
  process.env.NEXT_PUBLIC_IS_EDIT_ORDER_ENABLED === 'true'
